<template>
  <v-card dark outlined>
    <v-card-title class="secondary py-1 text-subtitle-1">
      <v-icon left dense> {{ icon }} </v-icon>
      {{ title }}
      <v-spacer />
      <v-btn
        v-for="button in buttons"
        :key="button.name"
        x-small
        dark
        @click="$emit(button.function)"
        class="ml-2"
      >
        <v-icon left x-small> {{ button.icon }} </v-icon>
        {{ button.name }}
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        single-select
        class="elevation-5"
        return-objects
      >
        <template v-slot:item.StallholderName="{ item }">
          {{ item.StallholderName ? item.StallholderName : "" }}
        </template>

        <template v-slot:item.Abn="{ item }">
          {{ item.Abn ? item.Abn : "" }}
        </template>

        <template v-slot:item.CardSurchargePercentage="{ item }">
          {{ item.CardSurchargePercentage }}
        </template>

        <template v-slot:item.PaymentProfile="{ item }">
          {{
            Array.isArray(item.PaymentProfile)
              ? item.PaymentProfile.join(", ")
              : ""
          }}
        </template>

        <template v-slot:item.PrintingProfile="{ item }">
          {{ item.PrintingProfile ? item.PrintingProfile : "" }}
        </template>

        <template v-slot:item.StandardDrinkLimit="{ item }">
          {{ item.StandardDrinkLimit ? item.StandardDrinkLimit : "" }}
        </template>

        <template v-slot:item.StandardDrinkLimitEnforce="{ item }">
          {{
            typeof item.StandardDrinkLimitEnforce === "boolean"
              ? item.StandardDrinkLimitEnforce
                ? "Enforce"
                : "Prompt"
              : item.StandardDrinkLimitEnforce || ""
          }}
        </template>

        <!-- Event-specific fields -->
        <template v-slot:item.EventName="{ item }">
          {{ item.EventName ? item.EventName : "" }}
        </template>

        <template v-slot:item.Year="{ item }">
          {{ item.Year ? item.Year : "" }}
        </template>

        <template v-slot:item.ShowInPOS="{ item }">
          {{ item.ShowInPOS ? item.ShowInPOS : "" }}
        </template>

        <!-- Stall-specific fields -->
        <template v-slot:item.StallName="{ item }">
          {{ item.StallName || "" }}
        </template>

        <template v-slot:item.OrderNumbers="{ item }">
          {{ item.OrderNumbers ? "Yes" : "No" }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="$emit('edit', item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="$emit('delete', item)"> mdi-delete </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary"> {{ noDataMessage }} </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EventManagementTable",
  props: {
    items: {
      type: Array,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-home",
    },
    title: {
      type: String,
      default: "Stallholders",
    },
    buttons: {
      type: Array,
      default: () => [
        {
          name: "Add StallHolder",
          icon: "mdi-plus",
          function: "create",
        },
      ],
    },
    noDataMessage: {
      type: String,
      default: "No data available for this event",
    },
    headers: {
      type: Array,
      default: () => [
        { text: "Stallholder Name", value: "StallholderName" },
        { text: "ABN", value: "Abn" },
        { text: "Card Surcharge (%)", value: "CardSurchargePercentage" },
        { text: "Payment Profile", value: "PaymentProfile" },
        { text: "Printing Profile", value: "PrintingProfile" },
        { text: "Standard Drink Limit", value: "StandardDrinkLimit" },
        { text: "Drink Limit Profile", value: "StandardDrinkLimitEnforce" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    },
  },
  data() {
    return {};
  },
};
</script>
